import React from 'react'
import { Link } from 'react-router-dom'
import image2 from '../assets/image-carousel-2.jpg'

const Services = () => {
  const servicesStyles = {
    container: {
      width: '100%',
      position: 'relative',
    },
    // Hero Section
    heroSection: {
      position: 'relative',
      padding: '150px 20px 100px',
      color: '#fff',
      textAlign: 'center',
      backgroundImage: `url(${image2})`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      minHeight: '600px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      zIndex: 1,
    },
    heroOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(6, 67, 95, 0.7)',
      zIndex: 1,
    },
    heroContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      position: 'relative',
      zIndex: 2,
    },
    heroTitle: {
      fontSize: '3rem',
      fontWeight: '700',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
      color: '#fff',
      textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
    },
    heroSubtitle: {
      fontSize: '1.3rem',
      lineHeight: '1.8',
      opacity: 0.95,
      maxWidth: '800px',
      margin: '0 auto',
      color: '#fff',
      textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    },
    // Services Section
    servicesSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    servicesContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    sectionTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      marginBottom: '30px',
      fontFamily: 'Poppins, sans-serif',
      textAlign: 'center',
    },
    sectionSubtitle: {
      fontSize: '1.2rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '30px',
      textAlign: 'center',
      maxWidth: '900px',
      margin: '0 auto 50px',
    },
    servicesGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))',
      gap: '40px',
      marginTop: '50px',
    },
    serviceCard: {
      backgroundColor: '#f8f9fa',
      padding: '50px 40px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      cursor: 'pointer',
    },
    serviceCardHover: {
      transform: 'translateY(-5px)',
      boxShadow: '0 10px 25px rgba(0, 0, 0, 0.15)',
    },
    serviceIcon: {
      fontSize: '4rem',
      marginBottom: '25px',
      color: 'var(--color-secondary)',
    },
    serviceTitle: {
      fontSize: '1.8rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
    },
    serviceDescription: {
      fontSize: '1.05rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '20px',
    },
    serviceFeatures: {
      listStyle: 'none',
      padding: 0,
      margin: 0,
    },
    serviceFeature: {
      fontSize: '1rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '12px',
      paddingLeft: '25px',
      position: 'relative',
    },
    serviceFeatureIcon: {
      position: 'absolute',
      left: 0,
      color: 'var(--color-secondary)',
    },
    // Detailed Services Section
    detailedSection: {
      padding: '80px 20px',
      backgroundColor: '#f8f9fa',
    },
    detailedContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    detailedContent: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(500px, 1fr))',
      gap: '50px',
      marginTop: '50px',
      alignItems: 'start',
    },
    detailedCard: {
      backgroundColor: '#fff',
      padding: '40px',
      borderRadius: '10px',
      boxShadow: '0 5px 15px rgba(0, 0, 0, 0.1)',
    },
    detailedTitle: {
      fontSize: '2rem',
      fontWeight: '700',
      color: 'var(--color-primary)',
      marginBottom: '20px',
      fontFamily: 'Poppins, sans-serif',
    },
    detailedText: {
      fontSize: '1.05rem',
      color: '#666',
      lineHeight: '1.8',
      marginBottom: '15px',
    },
    // Process Section
    processSection: {
      padding: '80px 20px',
      backgroundColor: '#fff',
    },
    processContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
    },
    processGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
      gap: '40px',
      marginTop: '50px',
    },
    processStep: {
      textAlign: 'center',
      padding: '30px 20px',
    },
    processNumber: {
      width: '60px',
      height: '60px',
      borderRadius: '50%',
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      fontSize: '1.8rem',
      fontWeight: '700',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      margin: '0 auto 20px',
      fontFamily: 'Poppins, sans-serif',
    },
    processTitle: {
      fontSize: '1.3rem',
      fontWeight: '600',
      color: 'var(--color-primary)',
      marginBottom: '15px',
    },
    processDescription: {
      fontSize: '1rem',
      color: '#666',
      lineHeight: '1.6',
    },
    // CTA Section
    ctaSection: {
      padding: '80px 20px',
      backgroundColor: 'var(--color-secondary)',
      color: '#fff',
      textAlign: 'center',
    },
    ctaContainer: {
      maxWidth: '800px',
      margin: '0 auto',
    },
    ctaTitle: {
      fontSize: '2.5rem',
      fontWeight: '700',
      marginBottom: '20px',
      color: '#fff',
    },
    ctaDescription: {
      fontSize: '1.2rem',
      lineHeight: '1.8',
      marginBottom: '40px',
      opacity: 0.95,
    },
    ctaButton: {
      backgroundColor: '#fff',
      color: 'var(--color-secondary)',
      padding: '15px 40px',
      fontSize: '1.1rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '5px',
      cursor: 'pointer',
      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
      textDecoration: 'none',
      display: 'inline-block',
    },
  };

  return (
    <div style={servicesStyles.container}>
      {/* Hero Section */}
      <section style={servicesStyles.heroSection} data-aos="fade-down">
        <div style={servicesStyles.heroOverlay}></div>
        <div style={servicesStyles.heroContainer}>
          <h1 style={servicesStyles.heroTitle}>Our Services</h1>
          <p style={servicesStyles.heroSubtitle}>
            Comprehensive offshore crew manning solutions tailored to meet your maritime 
            operations needs with excellence, safety, and professionalism.
          </p>
        </div>
      </section>

      {/* Main Services Section - 2 Sections */}
      <section style={servicesStyles.servicesSection} data-aos="fade-up">
        <div style={servicesStyles.servicesContainer}>
          <h2 style={servicesStyles.sectionTitle}>What We Offer</h2>
          <p style={servicesStyles.sectionSubtitle}>
            We serve two distinct groups: companies and industries seeking qualified crew, 
            and maritime professionals seeking employment opportunities.
          </p>
          <div style={servicesStyles.servicesGrid}>
            {/* Section 1: For Companies & Industries */}
            <div
              style={servicesStyles.serviceCard}
              data-aos="fade-up"
              data-aos-delay="100"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, servicesStyles.serviceCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={servicesStyles.serviceIcon}>🏢</div>
              <h3 style={servicesStyles.serviceTitle}>Crew for Companies & Industries</h3>
              <p style={servicesStyles.serviceDescription}>
                We provide crew members to companies and industries for both ship and offshore operations. 
                Our qualified crew pool includes deck officers, engineers, and support staff ready to 
                meet your maritime and offshore requirements.
              </p>
              <ul style={servicesStyles.serviceFeatures}>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Ship Crew (Deck, Engine, Catering)
                </li>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Offshore Crew (Rigs, Platforms, Vessels)
                </li>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Certified & Verified Professionals
                </li>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Crew Management & Deployment
                </li>
              </ul>
            </div>

            {/* Section 2: For Job Seekers */}
            <div
              style={servicesStyles.serviceCard}
              data-aos="fade-up"
              data-aos-delay="200"
              onMouseEnter={(e) => {
                Object.assign(e.currentTarget.style, servicesStyles.serviceCardHover);
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'translateY(0)';
                e.currentTarget.style.boxShadow = '0 5px 15px rgba(0, 0, 0, 0.1)';
              }}
            >
              <div style={servicesStyles.serviceIcon}>👤</div>
              <h3 style={servicesStyles.serviceTitle}>For Job Seekers</h3>
              <p style={servicesStyles.serviceDescription}>
                If you are a maritime professional looking for employment opportunities, we welcome 
                you to join our crew pool. We connect qualified seafarers and offshore workers with 
                companies and vessels worldwide.
              </p>
              <ul style={servicesStyles.serviceFeatures}>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Ship & Offshore Job Opportunities
                </li>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Career Placement Support
                </li>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Certification & Registration Guidance
                </li>
                <li style={servicesStyles.serviceFeature}>
                  <span style={servicesStyles.serviceFeatureIcon}>✓</span>
                  Global Employment Network
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Services Section */}
      <section style={servicesStyles.detailedSection} data-aos="fade-up">
        <div style={servicesStyles.detailedContainer}>
          <h2 style={servicesStyles.sectionTitle}>Service Details</h2>
          <div style={servicesStyles.detailedContent}>
            <div style={servicesStyles.detailedCard} data-aos="fade-right">
              <h3 style={servicesStyles.detailedTitle}>Crew for Companies & Industries</h3>
              <p style={servicesStyles.detailedText}>
                We supply crew members to shipping companies, offshore operators, and maritime industries 
                for both ship and offshore operations. Our crew pool includes deck officers, engineers, 
                technicians, and support staff who are certified, verified, and ready for deployment.
              </p>
              <p style={servicesStyles.detailedText}>
                Whether you need crew for your vessel, offshore platform, or maritime project, we work 
                closely with you to understand your requirements and deliver the right professionals at 
                the right time.
              </p>
            </div>
            <div style={servicesStyles.detailedCard} data-aos="fade-left">
              <h3 style={servicesStyles.detailedTitle}>For People Seeking Jobs</h3>
              <p style={servicesStyles.detailedText}>
                If you are a maritime professional looking for employment, we welcome you to register 
                with us. We connect qualified seafarers and offshore workers with companies and vessels 
                across the globe. Our team assists with placement, certification guidance, and career support.
              </p>
              <p style={servicesStyles.detailedText}>
                We maintain a strong network of employers and can help you find opportunities in ship 
                operations, offshore rigs, or maritime-related industries. Contact us to get started 
                on your career journey.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section style={servicesStyles.processSection} data-aos="fade-up">
        <div style={servicesStyles.processContainer}>
          <h2 style={servicesStyles.sectionTitle}>Our Process</h2>
          <div style={servicesStyles.processGrid}>
            <div style={servicesStyles.processStep} data-aos="zoom-in" data-aos-delay="100">
              <div style={servicesStyles.processNumber}>1</div>
              <h3 style={servicesStyles.processTitle}>Consultation</h3>
              <p style={servicesStyles.processDescription}>
                We begin by understanding your specific requirements and operational needs
              </p>
            </div>
            <div style={servicesStyles.processStep} data-aos="zoom-in" data-aos-delay="200">
              <div style={servicesStyles.processNumber}>2</div>
              <h3 style={servicesStyles.processTitle}>Selection</h3>
              <p style={servicesStyles.processDescription}>
                Our team identifies and selects the most qualified candidates for your needs
              </p>
            </div>
            <div style={servicesStyles.processStep} data-aos="zoom-in" data-aos-delay="300">
              <div style={servicesStyles.processNumber}>3</div>
              <h3 style={servicesStyles.processTitle}>Verification</h3>
              <p style={servicesStyles.processDescription}>
                All credentials, certifications, and backgrounds are thoroughly verified
              </p>
            </div>
            <div style={servicesStyles.processStep} data-aos="zoom-in" data-aos-delay="400">
              <div style={servicesStyles.processNumber}>4</div>
              <h3 style={servicesStyles.processTitle}>Deployment</h3>
              <p style={servicesStyles.processDescription}>
                Crew members are deployed with full support and ongoing management
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={servicesStyles.ctaSection} data-aos="fade-up">
        <div style={servicesStyles.ctaContainer}>
          <h2 style={servicesStyles.ctaTitle}>Ready to Get Started?</h2>
          <p style={servicesStyles.ctaDescription}>
            Contact us today to discuss your offshore crew manning needs and discover how 
            we can support your maritime operations with excellence and professionalism.
          </p>
          <Link
            to="/contact"
            style={servicesStyles.ctaButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.transform = 'scale(1.05)';
              e.currentTarget.style.boxShadow = '0 5px 20px rgba(0, 0, 0, 0.2)';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.transform = 'scale(1)';
              e.currentTarget.style.boxShadow = 'none';
            }}
          >
            Contact Us
          </Link>
        </div>
      </section>
    </div>
  )
}

export default Services